// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2087":"css/admin-app.6721","8482":"css/app.6721"}[chunkId] + ".css";
};